<script setup lang="ts">
  import { DocumentInfo } from "~/entities/DocumentInfo";

  interface Props {
    documentInfo: DocumentInfo;
    isFeatured: boolean;
    loading?: boolean;
  }
  const props = defineProps<Props>();

  const toPath = computed<string>(() => `/plan/${props.documentInfo?.plan.id}/document/${props.documentInfo?.id}`);

  const settingPath = props.documentInfo.isOwner
    ? `/plan/${props.documentInfo?.plan?.id}/distribute/document/${props.documentInfo?.id}/edit`
    : "";
</script>

<template>
  <MoleculesBaseFeaturedCard
    v-if="isFeatured"
    :tags="documentInfo?.tags"
    :image="documentInfo?.thumbnailImage"
    :title="documentInfo?.contentsTitle"
    :is-free="documentInfo?.isFree"
    :to-path="toPath"
    :publish-status="documentInfo?.publishStatus"
    :loading="loading"
    :publish-date-time="documentInfo?.postDateTime"
    :content-id="documentInfo?.id.toString()"
    :content-type="documentInfo?.contentsType"
    :is-unread="documentInfo?.isUnread"
    :good-count="documentInfo?.goodCount"
    :setting-path="settingPath"
    :document-total-page="documentInfo?.documentTotalPage"
    :is-good="documentInfo?.isGood"
    :description="documentInfo?.description"
    :is-bookmark="documentInfo?.isBookmark"
    :height="125"
    :sp-height="185"
  />
  <MoleculesBaseMovieCard
    v-if="!isFeatured"
    :tags="documentInfo?.tags"
    :image="documentInfo?.thumbnailImage"
    :live-title="documentInfo?.contentsTitle"
    :is-free="documentInfo?.isFree"
    :to-path="toPath"
    :publish-status="documentInfo?.publishStatus"
    :loading="loading"
    :publish-date-time="documentInfo?.postDateTime"
    :content-id="documentInfo?.id.toString()"
    :content-type="documentInfo?.contentsType"
    :is-unread="documentInfo?.isUnread"
    :good-count="documentInfo?.goodCount"
    :setting-path="settingPath"
    :document-total-page="documentInfo?.documentTotalPage"
    :is-good="documentInfo?.isGood"
    :is-bookmark="documentInfo?.isBookmark"
  />
</template>
